import React from 'react'

function ExternalViewsSkeleton() {
  return (
    <div className="relative flex h-screen w-full flex-col items-center justify-center overflow-hidden bg-secondaryColour">
      <div className="skeleton"></div>
    </div>
  )
}

export default ExternalViewsSkeleton
